import { LogOut, Settings } from 'lucide-react';

import { useAuth } from '@chainlit/react-client';
import { useRecoilValue, useRecoilState } from 'recoil';
import { profileState } from 'state/user';
import { userSettingsOpenState } from 'state/project';

import UserAvatar from '@/components/UserAvatar';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { Translator } from 'components/i18n';

export default function UserNav() {
  const { user, logout } = useAuth();
  const [, setSettingsOpen] = useRecoilState(userSettingsOpenState);
  const profile = useRecoilValue(profileState);

  if (!user) return null;
  const displayName = profile?.display_name || user?.identifier;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          id="user-nav-button"
          variant="ghost"
          className="relative h-8 w-8 rounded-full"
        >
          <UserAvatar
            identifier={user.identifier}
            displayName={displayName}
            providerImage={user.metadata?.image}
            className="h-8 w-8"
            fallbackClassName="text-xs"
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-26" align="end" forceMount>
        <DropdownMenuLabel className="font-normal">
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium leading-none">{displayName}</p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => setSettingsOpen(true)}>
          <Translator path="navigation.user.menu.settings" />
          <Settings className="ml-auto" />
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => logout(true)}>
          <Translator path="navigation.user.menu.logout" />
          <LogOut className="ml-auto" />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
